// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"co-z","play":"do-z"};